'use client'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useEffect, useState } from 'react'
import Slider, { Settings } from 'react-slick'
import { useMediaQuery } from '@mantine/hooks'
import { KTechPioneersList } from '../_data/ktechpioneers'
import { ChallengeCard } from './ChallengeCard'

function useWindowWidth() {
  const [width, setWidth] = useState(0)
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth)
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return width
}

export default function ChallengePreview() {
  const isCustom = useMediaQuery('(max-width: 1279px)')
  const windowWidth = useWindowWidth()
  const list = KTechPioneersList

  // 초기 렌더 시 isCustom 값이 정해질 때까지 대기
  if (isCustom === undefined) return null

  const settings: Settings = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    arrows: true,
    variableWidth: true,
    touchMove: true,
    centerMode: true,
    centerPadding: '0px',
    initialSlide: isCustom ? 0 : 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          centerMode: false,
          touchMove: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          centerMode: false,
          touchMove: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          centerMode: false,
          touchMove: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          centerMode: false,
          touchMove: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          centerMode: false,
          touchMove: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          centerMode: false,
          touchMove: true,
          variableWidth: false,
        },
      },
    ],
  }

  return (
    <Slider {...settings}>
      {list.map((item, idx) => (
        <div key={idx} className="pr-4 pb-[68px] pc:pb-20">
          <ChallengeCard item={item} compact />
        </div>
      ))}
    </Slider>
  )
}
